// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6ec2b692","977":"dbc3484d"}[chunkId] + ".chunk.js";
};